import styled, { css } from 'styled-components';

export type Intent = 'bad' | 'neutral' | 'good' | 'info' | 'none';

export interface PillProps {
  as?: string;
  intent?: Intent;
  pillShape?: boolean;
  fontColor?: string;
}

const color = css<PillProps>`
  ${({ intent, theme }) => {
    switch (intent) {
      case 'bad':
        return theme.color.bad;
      case 'good':
        return theme.color.good;
      case 'neutral':
        return theme.color.neutral;
      case 'info':
        return theme.color.brand01;
      default:
        return theme.color.spaceGray;
    }
  }};
`;

const Pill = styled('mark').attrs<PillProps>(({ as }) => ({
  as,
}))`
  border-radius: ${({ theme, pillShape }) =>
    pillShape ? `${theme.x2spacePx}px` : `${theme.x1spacePx}px`};
  background-color: ${color};
  margin: 0 ${({ theme }) => theme.x1spacePx / 2}px;
  padding: ${({ theme }) => `${theme.x1spacePx / 4}px ${theme.x1spacePx}px`};
  color: ${({ fontColor }) => (fontColor ? fontColor : 'inherit')};
  white-space: nowrap;
  text-decoration: none;
  height: min-content;
`;

export default Pill;
